export class Nomina{
	public loacs:any;
	public fechaInicio: string;
	public fechaFin: string;

	constructor(){}
}


// WEBPACK FOOTER //
// ./src/app/models/nomina.ts